import { Component, computed, inject, viewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ExpertisesObject, ServiceGridItemObject } from '@it2go/types';
import { ServicesPageStore } from './services-page.store';
import { successDeleted } from '../../../content.error';
import { FilterBuilder } from '../../../helper/filter.builder';
import { ConfirmBuilder } from '../../../../shared/service/confirm.builder';
import { TableComponent } from '../../../../shared/components/kit/table/table.component';
import { colorColumn, nameColumn } from '../../../../shared/components/kit/table/table.fields';
import { TranslateService } from '@ngx-translate/core';
import { BaseDialogService } from '../../../../../components/kit/base-dialog/base-dialog-service';
import { ServiceCreateDialogComponent } from '../service-create-dialog/service-create-dialog.component';

@Component({
    selector: 'app-services-page',
    templateUrl: './services-page.component.html',
    providers: [ServicesPageStore],
    imports: [
        TableComponent,
    ],
})
export class ServicesPageComponent {

    public readonly store = inject(ServicesPageStore);
    public readonly router = inject(Router);
    public readonly route = inject(ActivatedRoute);
    public readonly confirmBuilder = inject(ConfirmBuilder);
    public readonly dialogService = inject(BaseDialogService);
    public readonly translate = inject(TranslateService);

    public readonly table = viewChild<TableComponent>('serviceTable');

    protected columns = [
        colorColumn,
        nameColumn,
        {
            name: 'type',
            dataKey: 'serviceType.name',
        },
        {
            name: 'expertise',
            data: (it: ExpertisesObject) => it ? `${it.code} - ${it.name}` : '',
        },
    ];

    protected additionalFilter = computed(() => FilterBuilder.additionalFilter({
        organizationId: this.store.globalGlobalStore.organizationStore.selectedId(),
    }));

    public async detailService(service: ServiceGridItemObject) {
        await this.router.navigate([`./${service.id}`], { relativeTo: this.route });
    }

    public async deleteService(event: any): Promise<void> {
        this.confirmBuilder.confirmDelete(
            async () => {
                await this.store.api.deleteService({ id: event.item.id });
                successDeleted();
                this.table()?.reload();
            },
            event,
        );
    }

    public createService() {
        this.dialogService.open(ServiceCreateDialogComponent,
            {
                header: this.translate.instant('service.create'),
                styleClass: 'p-dialog-width-70',
            });
    }
}
